import { render, staticRenderFns } from "./TransactionDetails.vue?vue&type=template&id=49cc98f0"
import script from "./TransactionDetails.vue?vue&type=script&lang=js"
export * from "./TransactionDetails.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetails.vue?vue&type=style&index=0&id=49cc98f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports